var pageNum = 1;
var topicPageNum = 1;
var $listDocPrototype, $listDocDateDivider;
function loadContent(append,contentTypes){
	var topics = [];
	$('.topicCheckbox').each(function(){
		if($(this).is(':checked')){
			topics.push($(this).attr('name'));
		}
	});
	var url = '/getmore';
	var pageSize = 10;
	if(append){
		pageNum++;
	}else{
		pageNum = 1;
		$('#listDocContainer .container').empty();
	}
	$.ajax({
		url: url,
		data: {
			contentTypes: contentTypes,
			pageSize: pageSize,
			pageNum: pageNum,
			topics: topics
		},
		success:function(data){
			if(data.Content.length > 0){
				var empty = !append;
				var previousDate = "";
				var month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
				for(var i = 0; i < data.Content.length; i++){
					var $tempDateObj = $listDocDateDivider.clone();
					var $tempDocObj = $listDocPrototype.clone();
					var newDocDate = new Date(data.Content[i].published);
					if(previousDate == "")
						previousDate = new Date($tempDateObj.find('.topicTags').text());
					if(empty || newDocDate.getMonth() != previousDate.getMonth() || newDocDate.getFullYear() != previousDate.getFullYear()){
						empty = false;
						$tempDateObj.find('.topicTags').text(month[newDocDate.getMonth()] + ' ' + newDocDate.getFullYear());
						$tempDateObj.appendTo('#listDocContainer .container');
						$('#listDocContainer .container').append("<div class='listDocSubcontainer'></div>");
						previousDate = newDocDate;
					}
					var topicClass = data.Content[i].parentTopic.replace(/ /g, '').toLowerCase() + "Topic";
					var topicUrl = data.Content[i].topicTag.replace(/ /g, '-').toLowerCase();
					$tempDocObj.find('.topicTags').removeClass().addClass('topicTags topicTagButtons '+topicClass).attr('href','/'+topicUrl).text(data.Content[i].topicTag);
					var itemRoute = (typeof data.Content[i].filePath != 'undefined' && data.Content[i].filePath != '' && data.Content[i].filePath != 'http://media.aclj.org/pdf/') ? data.Content[i].filePath : "/" + data.Content[i].route
					$tempDocObj.find('.docDesc a').attr('href',itemRoute).text(data.Content[i].title);
					$tempDocObj.find('.docDesc .timestamp').text(fullDate(data.Content[i].published));

					$('.listDocSubcontainer').last().append($tempDocObj);
				}
			}
			if(data.Content.length < pageSize) {
				$('.readMoreContainer').parent().hide();
			} else {
				$('.readMoreContainer').parent().show();
			}
		},
		dataType: "json"
	});
}